import { Component, ChangeDetectorRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { Store } from '@ngrx/store';
import { takeUntil, Subject } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import type { RequisitionAssignment } from '@core/requisitions-types';
import { RequisitionAssignmentsSelectors } from '@recruitee/requisitions-data';

import { RequisitionsTeamContainerComponent } from '../../../containers/single-requisition/requisitions-team-container/requisitions-team-container.component';

@Component({
  selector: 'rt-requisitions-team-page',
  templateUrl: './team-page.component.html',
  styleUrls: ['./team-page.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [RequisitionsTeamContainerComponent],
})
export class TeamPageComponent {
  private readonly store = inject(Store);
  private readonly route = inject(ActivatedRoute);
  private readonly cdRef = inject(ChangeDetectorRef);

  public requisitionId: number;
  public assignments: RequisitionAssignment[];

  private ngOnDestroy$ = new Subject<void>();

  public ngOnInit(): void {
    const id = Number(this.route.parent?.snapshot.params.id);

    this.requisitionId = id;
    this.cdRef.detectChanges();

    this.store
      .select(RequisitionAssignmentsSelectors.byId(id))
      .pipe(filterBoolean, takeUntil(this.ngOnDestroy$))
      .subscribe(data => {
        this.assignments = data.assignments;
        this.cdRef.detectChanges();
      });
  }

  public ngOnDestroy() {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
